import { useState } from "react";
import { AlertTriangle } from "lucide-react";

const CONFIRM_WORD = "LÖSCHEN";

/**
 * Type-to-confirm modal for irreversible hard-delete. Disabled until the user
 * literally types "LÖSCHEN" into the input field.
 */
export const HardDeleteModal = ({ user, onConfirm, onCancel }) => {
  const [confirmText, setConfirmText] = useState("");
  if (!user) return null;

  const close = () => {
    setConfirmText("");
    onCancel();
  };

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center px-4 bg-black/80 backdrop-blur-sm"
      data-testid="hard-delete-modal"
    >
      <div className="nv-card w-full max-w-md p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-full bg-red-500/15 border border-red-500/40 flex items-center justify-center">
            <AlertTriangle className="w-5 h-5 text-red-400" />
          </div>
          <h3 className="font-display font-black text-xl text-white">Endgültig löschen?</h3>
        </div>
        <p className="text-sm text-novatus-text-2 leading-relaxed mb-4">
          Du löschst <strong className="text-white">
            {user.original_first_name || user.first_name}{" "}
            {user.original_last_name || user.last_name}
          </strong> dauerhaft. Dies entfernt unwiderruflich:
        </p>
        <ul className="text-xs text-novatus-text-2 list-disc list-inside space-y-1 mb-4 pl-1">
          <li>Den Nutzer-Account</li>
          <li>Alle Training-Sessions & Chat-Verläufe</li>
          <li>Coaching-Feedbacks & Voice-Analytics</li>
          <li>Audio-Aufnahmen in Hetzner S3</li>
          <li>Offene Zuweisungen & OTPs</li>
        </ul>
        <label className="block text-xs text-novatus-text-2 mb-2">
          Tippe <span className="font-mono text-red-400 font-bold">{CONFIRM_WORD}</span> ein, um zu bestätigen:
        </label>
        <input
          type="text"
          value={confirmText}
          onChange={(e) => setConfirmText(e.target.value)}
          className="nv-input w-full mb-5"
          placeholder={CONFIRM_WORD}
          autoFocus
          data-testid="hard-delete-confirm-input"
        />
        <div className="flex gap-2 justify-end">
          <button
            onClick={close}
            className="h-10 px-4 rounded-lg border border-novatus bg-novatus-card-2 hover:bg-white/5 text-white text-sm"
            data-testid="hard-delete-cancel"
          >
            Abbrechen
          </button>
          <button
            onClick={() => { onConfirm(user); setConfirmText(""); }}
            disabled={confirmText !== CONFIRM_WORD}
            className="h-10 px-4 rounded-lg bg-red-500 hover:bg-red-600 disabled:opacity-40 disabled:cursor-not-allowed text-white font-semibold text-sm inline-flex items-center gap-1.5"
            data-testid="hard-delete-confirm"
          >
            <AlertTriangle className="w-4 h-4" /> Endgültig löschen
          </button>
        </div>
      </div>
    </div>
  );
};
